import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaValorEmAberto = (): TabelaColuna => ({
  Chave: 'valorEmAberto',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.moeda(linha.valorEmAberto)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Valor em aberto</div>
})
